<template>
    <core-view class="flex-column" fill-height>
        <v-overlay v-show="((progresso !== 100) && (totalItem > minimoParaLoading)) || primeiroUpdate">
            <v-snackbar  timeout="2000000" v-if="primeiroUpdate" v-model="alwaysTrue">
              <p>Trazendo dados pela primeira vez...</p>
            </v-snackbar>
            <v-snackbar timeout="2000000" v-model="snackbar" v-else>
                <p>Grande número de itens para atualizar, aguarde...</p>
                <p>{{ itemsProcessados }} de {{ totalItem }}</p>
                <v-progress-linear color="primary" :value="progresso"></v-progress-linear>
            </v-snackbar>
        </v-overlay>

        
        <!-- <v-textarea class="debug" v-model="$_debug" :value="$_debug">
        </v-textarea>

        <v-textarea class="debug" :key="key" v-for="(value, index, key) in debug" :messages="value" :value="debugData[index]">
        </v-textarea> -->
        <v-snackbar 
          v-if="totalItem > 10"
          color="primary"
          timeout="6000"
          v-model="snackbarSucesso"
        >
          <v-icon class="snackbar__icon">
            mdi-check-circle
          </v-icon>
          Dados atualizados com sucesso!
        </v-snackbar>
    </core-view>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CoreView from '@/components/core/view/Index.vue';
// import { TOKEN, USER_STORAGE } from '@/constants/STORAGE';
import { SetupEnvioLocal } from '@/utils/atualizalocal';
// import db from '@/plugins/dexie';

// function getSessionStorage(key, defaultValue) {
//   return sessionStorage.getItem(key) ?? defaultValue;
// }

export default {
  name: 'ViewHome',

  components: {
    CoreView,
  },

  data() {
    return {
      snackbar: true,
      snackbarSucesso: false,
      alwaysTrue: true,
      debug: [],
      debugData: [],
    };
  },

  computed: {
    ...mapState('atualizalocal', [
      'totalItem',
      'itemsProcessados',
      'progresso',
      'minimoParaLoading',
      'estaAdicionado',
      'estaAtualizado',
      'primeiroUpdate',
    ]),
    ...mapState({
      $_debug: (state) => state.debug.debugArrayDataAtt
    })
  },

  watch: {
    progresso(valor) {
      console.log(valor, 'valor');
      if (valor === 100) {
        this.snackbarSucesso = true;
        this.$_primeiroUpdate(false);
      }
    },
    primeiroUpdate(valor) {
      if (valor) {
        setTimeout(() => {
          if (valor) {
            console.log('Está demorando mais que o normal!');
          }
        }, 5000)
      }
    }
  },

  methods: {
    ...mapActions({
      $_recebimentosFind: 'recebimento/find',
      $_findFila: 'fila/find',
      $_findUserId: 'users/findByWebId',
      $_primeiroUpdate: 'cache/primeiroUpdate'
    }),

    // async $_setupIdUsuario() {
    //   const token = JSON.parse(await getSessionStorage(TOKEN, ''));
    //   const data = await this.$_findUserId({ id: token.userId });
    //   sessionStorage.setItem(USER_STORAGE.useidusuario, data.useidusuario);
    // }
  },

  async created() {
/*     db.tables.forEach(async (table) => {
      this.debug.push(table.name);
      this.debugData.push(await db[table.name].toArray());
    });
    console.log('debug', this.$_debug)
    console.log(this.debug); */
    // this.$_setupIdUsuario();
    SetupEnvioLocal();
  },
};
</script>

<style scoped>
.v-sheet--offset {
  top: 5px;
  position: relative;
}

.center {
  width: 100%;
  text-align: center;
}

.snackbar__icon {
  margin-right: 15px;
}
.debug {
  width: 100%;
}
</style>
